/* Productpagina in Montleigh-stijl (pdp-*): verversen bij variantwissel, sticky
   winkelbalk, "Load more reviews", aanbevelingen en iconen-slider.
   Werkt bovenop de Horizon-onderdelen; winkelmandje en varianten blijven van Horizon. */
(() => {
  if (window.__pdpLoaded) return;
  window.__pdpLoaded = true;

  /* ---------- Blokken verversen bij een andere variant ----------
     Horizon stuurt bij elke variantwissel 'variant:update' met de nieuwe HTML van
     de sectie. Blokken met data-pdp-live nemen hun nieuwe inhoud daaruit over. */
  document.addEventListener('variant:update', (event) => {
    const html = event.detail && event.detail.data && event.detail.data.html;
    if (!html || typeof html.querySelectorAll !== 'function') return;
    const section = event.target instanceof Element ? event.target.closest('.shopify-section') : null;
    const scope = section || document;
    html.querySelectorAll('[data-pdp-live]').forEach((fresh) => {
      const current = scope.querySelector(`[data-pdp-live="${fresh.dataset.pdpLive}"]`);
      if (current) current.innerHTML = fresh.innerHTML;
    });
  });

  /* ---------- Sticky winkelbalk ---------- */
  function bindSticky(bar) {
    const section = bar.closest('.shopify-section') || document;
    const mainButton = () => section.querySelector('add-to-cart-component button[type="submit"], [ref="addToCartButton"]');
    let shown = false;

    const check = () => {
      const btn = mainButton();
      if (!btn) return;
      const passed = btn.getBoundingClientRect().bottom < 0;
      if (passed === shown) return;
      shown = passed;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', String(!passed));
      const stickyBtn = bar.querySelector('[data-pdp-sticky-atc]');
      if (stickyBtn) stickyBtn.tabIndex = passed ? 0 : -1;
    };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();

    // Klik doorgeven aan de gewone winkelknop: zelfde winkelmandje, zelfde gedrag.
    bar.addEventListener('click', (e) => {
      const stickyBtn = e.target.closest('[data-pdp-sticky-atc]');
      if (!stickyBtn || stickyBtn.disabled) return;
      mainButton()?.click();
    });
  }

  /* ---------- Load more reviews ---------- */
  function bindReviews(list) {
    const button = list.parentElement.querySelector('[data-pdp-reviews-more]');
    if (!button) return;
    const step = Number(list.dataset.step) || 3;
    button.addEventListener('click', () => {
      const hidden = [...list.querySelectorAll('.pdp-review.is-hidden')];
      hidden.slice(0, step).forEach((r) => r.classList.remove('is-hidden'));
      if (hidden.length <= step) button.parentElement.remove();
    });
  }

  /* ---------- Aanbevelingen ---------- */
  async function loadRecommendations(el) {
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('.pdp-combine__inner');
      if (inner) el.replaceChildren(inner);
    } catch (e) {
      /* geen aanbevelingen: sectie blijft leeg */
    }
  }

  /* ---------- Iconen-slider (mobiel) ---------- */
  function bindIcons(track) {
    const dots = [...(track.parentElement.querySelector('[data-pdp-icons-dots]')?.children || [])];
    if (!dots.length) return;
    dots.forEach((d, i) =>
      d.addEventListener('click', () => track.scrollTo({ left: track.children[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }))
    );
    track.addEventListener(
      'scroll',
      () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      },
      { passive: true }
    );
  }

  /* ---------- Sterrenregel bij de titel ----------
     De reviewsectie rekent score en aantal uit; die zetten we hier bij de titel. */
  function fillRating() {
    const data = document.querySelector('[data-pdp-rating-data]');
    const count = data ? Number(data.dataset.count) : 0;
    document.querySelectorAll('[data-pdp-rating-slot]').forEach((slot) => {
      if (!count) {
        slot.hidden = true;
        return;
      }
      const avg = data.dataset.avg;
      const countText = count.toLocaleString('en-US');
      slot.querySelector('.pdp-rating__text').textContent = (slot.dataset.text || '')
        .replace('[rating]', avg)
        .replace('[count]', countText);
      const stars = slot.querySelector('.pdp-stars');
      if (stars) stars.style.setProperty('--fill', `${Math.min(100, Number(avg) * 20)}%`);
      slot.hidden = false;
      slot.classList.remove('is-pending');
    });
  }

  /* ---------- Size Chart naast "Size" ----------
     De Kiwi-app zet zijn knop onder de maten; Montleigh toont hem naast het woord
     "Size". We verplaatsen de Kiwi-container (met zijn eigen klikgedrag) naar de
     maatkop. Horizon tekent de kiezer opnieuw bij een variantwissel; de observer
     zet hem dan terug. Zonder maatoptie blijft de knop gewoon op zijn plek. */
  const SIZE_LEGEND = /^\s*(size|sizes|shoe size|maat|taille)\b/i;
  let sizeChart = null;
  let sizeChartHome = null;

  function placeSizeChart() {
    const info = document.querySelector('.pdp-scope')?.closest('.product-information');
    if (!info) return;
    if (!sizeChart) {
      sizeChart = info.querySelector('.shopify-app-block .ks-container-app-block');
      if (!sizeChart) return;
      sizeChartHome = sizeChart.parentElement;
    }
    const legend = [...info.querySelectorAll('variant-picker fieldset:not(.variant-option--swatches) > legend')].find(
      (l) => SIZE_LEGEND.test(l.textContent)
    );
    if (!legend) {
      if (sizeChartHome && !sizeChartHome.contains(sizeChart)) sizeChartHome.append(sizeChart);
      if (sizeChartHome) sizeChartHome.hidden = false;
      return;
    }
    if (legend.contains(sizeChart)) return;
    let slot = legend.querySelector('.pdp-size-chart-slot');
    if (!slot) {
      slot = document.createElement('span');
      slot.className = 'pdp-size-chart-slot';
      legend.append(slot);
    }
    slot.append(sizeChart);
    if (sizeChartHome) sizeChartHome.hidden = true;
  }

  function watchSizeChart() {
    const info = document.querySelector('.pdp-scope')?.closest('.product-information');
    if (!info || info.__pdpSizeChart) return;
    info.__pdpSizeChart = true;
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(() => {
        queued = false;
        placeSizeChart();
      }, 0);
    }).observe(info, { childList: true, subtree: true });
    placeSizeChart();
  }

  function once(el) {
    if (el.__pdp) return false;
    el.__pdp = true;
    return true;
  }

  function init(scope = document) {
    fillRating();
    watchSizeChart();
    scope.querySelectorAll('[data-pdp-sticky]').forEach((el) => once(el) && bindSticky(el));
    scope.querySelectorAll('[data-pdp-reviews]').forEach((el) => once(el) && bindReviews(el));
    scope.querySelectorAll('[data-pdp-icons]').forEach((el) => once(el) && bindIcons(el));
    scope.querySelectorAll('[data-pdp-recs]').forEach((el) => {
      if (!once(el)) return;
      if (!('IntersectionObserver' in window)) return loadRecommendations(el);
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          loadRecommendations(el);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  // Theme editor: secties opnieuw initialiseren na bewerken.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => init(e.target.closest('.shopify-section') || document));
})();
